import { useEffect, useState } from "react";
import { Viewer } from "@react-pdf-viewer/core";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";

const DocumentViewer = ({ src, contentType, title }) => {
    const [url, setUrl] = useState(null);
    const [docTitle, setDocTitle] = useState(title);
    const toolbarPluginInstance = toolbarPlugin();
    const { Toolbar } = toolbarPluginInstance;

    function base64ToBlob(base64, mimeType) {
        try {
            const binary = atob(base64);
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
            return new Blob([bytes], { type: mimeType });
        } catch (err) {
            console.error("Base64 decoding failed:", err);
            return null;
        }
    }
    useEffect(() => {
        if (src && contentType) {
            const blob = base64ToBlob(src, contentType);
            if (blob) {
                const objectURL = URL.createObjectURL(blob);
                setUrl(objectURL);
            } else {
                console.error("Failed to create blob");
            }
        }
    }, [src, contentType]);

    useEffect(() => {
        if (title) setDocTitle(title);
    }, [title]);

    return (
        <div
            className="rpv-core__viewer"
            style={{
                border: "1px solid #ddd",
                display: "flex",
                flexDirection: "column",
                maxHeight: "82vh",
                borderRadius: "6px",
            }}
        >
            <div
                style={{
                    alignItems: "center",
                    backgroundColor: "#f9f9f9",
                    borderBottom: "1px solid #ddd",
                    display: "flex",
                    padding: "4px",
                }}
            >
                <Toolbar>
                    {(props) => {
                        const {
                            CurrentPageInput,
                            EnterFullScreen,
                            GoToFirstPage,
                            GoToNextPage,
                            GoToPreviousPage,
                            GoToLastPage,
                            NumberOfPages,
                            ShowSearchPopover,
                            Zoom,
                            ZoomIn,
                            ZoomOut,
                        } = props;
                        return (
                            <>
                                <div style={{ padding: "0px 2px" }}>
                                    <ShowSearchPopover />
                                </div>
                                <div style={{ padding: "0px 2px" }}>
                                    <GoToFirstPage />
                                </div>
                                <div style={{ padding: "0px 2px" }}>
                                    <GoToPreviousPage />
                                </div>
                                <div style={{ padding: "0px 2px", width: "3rem" }}>
                                    <CurrentPageInput />
                                </div>
                                <div style={{ padding: "0px 2px" }}>
                                    / <NumberOfPages />
                                </div>
                                <div style={{ padding: "0px 2px" }}>
                                    <GoToNextPage />
                                </div>
                                <div style={{ padding: "0px 2px" }}>
                                    <GoToLastPage />
                                </div>
                                <div style={{ padding: "0px 2px" }}>
                                    <span>{docTitle}</span>
                                </div>
                                <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
                                    <ZoomOut />
                                </div>
                                <div style={{ padding: "0px 2px" }}>
                                    <Zoom />
                                </div>
                                <div style={{ padding: "0px 2px" }}>
                                    <ZoomIn />
                                </div>
                                <div style={{ padding: "0px 2px" }}>
                                    <EnterFullScreen />
                                </div>
                            </>
                        );
                    }}
                </Toolbar>
            </div>

            <div className="scroll-no-buttons" style={{ height: "100%", overflow: "auto" }}>
                {url ? (
                    <Viewer fileUrl={url} plugins={[toolbarPluginInstance]} />
                ) : (
                    <div style={{ padding: 20 }}>PDF loading failed or invalid file</div>
                )}
            </div>
        </div>
    );
};

export default DocumentViewer;
